export default class HeroVideo {
	static init() {
		HeroVideo.setSizes();
		window.addEventListener('resize', HeroVideo.setSizes);
	}

	static setSizes() {
		Array.from(document.querySelectorAll('.hero-video picture.h-full')).forEach(picture => {
			let img = picture.querySelector('img.object-cover');
			if(!img) return;

			// check if the aspect ratio of the image inside the current box causes the image to be unsharp
			let sizes = window.innerWidth < 1080 ? (Math.ceil(picture.offsetHeight / img.getAttribute('height') * img.getAttribute('width')) + 'px') : '100vw';

			img.setAttribute('sizes', sizes);
			Array.from(picture.querySelectorAll('source')).forEach(source => source.setAttribute('sizes', sizes));
		});
	}
}
